import { FC } from "react";
import Button from "../ui/Button";
import { labelForEntity } from "./changeHistoryLabels";

// What the cell needs to know; both a history row and an action group satisfy it.
export interface IEntityRef {
  entityName: string;
  entityId: number;
  // The backend's name for the row ("Prishtinë - Pejë 08:30"); the id is the fallback.
  entityDisplay?: string | null;
  parentEntityName?: string | null;
  parentEntityId?: number | null;
  parentEntityDisplay?: string | null;
}

interface IEntityCell {
  row: IEntityRef;
  // The filter the list is currently narrowed to, so the parent line is hidden when it would repeat it.
  currentEntityName: string;
  currentEntityId: string;
  onPickEntity: (entityName: string, entityId: number) => void;
}

// "Ndalesa e orarit Prishtinë 08:00", and underneath it the entity it belongs to, "nën Orari
// Prishtinë - Pejë 08:30"; both narrow the list. Ids stand in when the backend knows no name.
const EntityCell: FC<IEntityCell> = ({ row, currentEntityName, currentEntityId, onPickEntity }) => {
  const parentIsTheFilter =
    row.parentEntityName === currentEntityName && String(row.parentEntityId) === currentEntityId;
  const showParent = !!row.parentEntityName && !!row.parentEntityId && !parentIsTheFilter;

  return (
    <span className="flex flex-col items-start">
      <Button
        btnType="custom"
        padding="px-0 py-0"
        fontWeight="font-medium"
        className="text-primary hover:underline text-left max-w-[15rem] truncate"
        title={`${labelForEntity(row.entityName)} ${row.entityDisplay ?? ""} (${row.entityName} #${
          row.entityId
        }): shfaq vetëm këtë`}
        onClick={() => onPickEntity(row.entityName, row.entityId)}
      >
        {labelForEntity(row.entityName)} {row.entityDisplay ?? `#${row.entityId}`}
      </Button>
      {showParent && (
        <Button
          btnType="custom"
          padding="px-0 py-0"
          fontWeight="font-normal"
          className="text-xs text-gray-500 hover:underline text-left max-w-[15rem] truncate"
          title={`${labelForEntity(row.parentEntityName as string)} ${
            row.parentEntityDisplay ?? `#${row.parentEntityId}`
          }: shfaq historikun e prindit`}
          onClick={() => onPickEntity(row.parentEntityName as string, row.parentEntityId as number)}
        >
          nën {labelForEntity(row.parentEntityName as string)}{" "}
          {row.parentEntityDisplay ?? `#${row.parentEntityId}`}
        </Button>
      )}
    </span>
  );
};

export default EntityCell;
